import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { marcoOpSesa_item } from "../../../json/marcoOpSesa";
import "./stylessh.css";

const MarcoOpSesa = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Instrumentos Normativos SESA</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>
      <div className="row overflow-auto">
        <table className="table-responsive table-bordered">
          <thead>
            <tr>
              <th className="colortabla" scope="col">Instrumentos</th>
              {marcoOpSesa_item[0].marcoOpSesa_item_years.map((item) => (
                <th className="colortabla" scope="col" key={item.marcoOpSesa_item_year}>
                  {item.marcoOpSesa_item_year}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {marcoOpSesa_item.map((instrumento, index) => (
              <tr className="text-size-font" key={index}>
                <th className="text-size-font fs14 colortabla" scope="row">{instrumento.marcoOpSesa_item_instrumento}</th>
                {instrumento.marcoOpSesa_item_years.map((year) => (
                  <td className="text-size-font fs14" key={year.marcoOpSesa_item_year}>
                    {Array.isArray(year.marcoOpSesa_item_contenido) ? (
                      year.marcoOpSesa_item_contenido.map((contenido, index) => (
                        <div key={index}>{contenido}</div>
                      ))
                    ) : (
                      <div>{year.marcoOpSesa_item_contenido}</div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MarcoOpSesa;
